import * as actionTypes from "./actionTypes";

// Refund Order
export const mallRefundOrder = (id, data) => {
  return {
    type: actionTypes.MALL_REFUND_ORDER,
    id,
    data
  };
};

export const mallRefundOrderSuccess = () => {
  return {
    type: actionTypes.MALL_REFUND_ORDER_SUCCESS
  };
};

export const mallRefundOrderFail = () => {
  return {
    type: actionTypes.MALL_REFUND_ORDER_FAIL
  };
};
// END Refund Order

// Withdraw Refund
export const mallWithdrawRefund = (id, orderID) => {
  return {
    type: actionTypes.MALL_WITHDRAW_REFUND,
    id,
    orderID
  };
};

export const mallWithdrawRefundSuccess = () => {
  return {
    type: actionTypes.MALL_WITHDRAW_REFUND_SUCCESS
  };
};

export const mallWithdrawRefundFail = () => {
  return {
    type: actionTypes.MALL_WITHDRAW_REFUND_FAIL
  };
};
// END Withdraw Refund
